/**
 * created by lei lei on 2020/6/10
 */
import React, {Component} from 'react';
import  Editor135 from'./Editor135'
import {getStuffById, saveStuff} from "../../../actions/weiChat";
export default class EditorComponents135 extends Component {
    static defaultProps = {
        mediaCode: '',
        stuffId:0,
        title: '',
        abstract: '',
        imageUrl: '',
        content: '',
        isUpdate: false,
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        let stuffId = this.props.match.params.stuffId;
        let mediaCode = this.props.match.params.mediaCode;
        this.state = { stuffId,mediaCode};
        if(stuffId > 0){
            this.getStuffData();
        }
    }

    getStuffData = () =>{
        getStuffById({stuffId: this.state.stuffId}, (data) => {
            this.setState({
                title: data.title,
                summary: data.summary,
                titlePic: data.titlePic,
                content: data.content,
                isUpdate: true
            });
        });
    };

    clickFinishEdit = (data) => {
        console.log('页面要保存的数据',data);
        let params = {...data};
        params.mediaCode = this.state.mediaCode;
        params.id = this.state.stuffId;
        params.content = data.content;
        saveStuff(params,() =>{
            // 关闭编辑器窗口并且刷新素材列表
            //增加判断解决报错
            if(window.opener&& window.opener.weChatEditCallBack){
                window.opener.weChatEditCallBack&&window.opener.weChatEditCallBack(window.opener.weChatEditCallBackParam);
            }
           window.close();
        });
    };

    render() {
        return (
            <Editor135
                clickFinishEdit={(data) => this.clickFinishEdit(data)}
                {...this.state}
            />
        )
    }

}